import { render, staticRenderFns } from "./SimpleInfographicCard.vue?vue&type=template&id=24eee4ba&scoped=true"
import script from "./SimpleInfographicCard.vue?vue&type=script&lang=js"
export * from "./SimpleInfographicCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleInfographicCard.vue?vue&type=style&index=0&id=24eee4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eee4ba",
  null
  
)

export default component.exports